import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import instance from './endpoint';
import { toast } from "react-toastify";
import Loader from '../components/utilComponents/loader';

const isAuthenticated = async () => {
  try {
    const response = await instance.get('/api/v1/auth/isLoggedin');
    console.log("Response data:", response.data); // Debugging

    // Check if user has the correct role
    if (response.status === 200 && response.data.role === "User") {
      return true;
    } else {
      toast.error("Access denied: Only regular users can access this page.");
      return false;
    }
  } catch (error) {
    console.error("Auth error:", error);
    toast.error("You are not logged in or do not have access.");
    return false;
  }
};

const ProtectedRoute = () => {
  const [authenticated, setAuthenticated] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const result = await isAuthenticated();
      setAuthenticated(result);
    };

    checkAuth();
  }, []);

  if (authenticated === null) {
    return <Loader />; // Show loading spinner
  }

  return authenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
